module.exports = __webpack_public_path__ + "img/pro_eight_5.32e12d2e.jpg";